// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * TYPE OF EQUIPMENT in Transmodel, referenced as a classification of an `Equipment`.
 * @export
 * @interface EquipmentType
 */
export interface EquipmentType {
    /**
     * Id of the equipment type:<br>x-extensible-enum: [WIFI] as in `EquipmentTypeEnum`
     * * `WIFI` free internet connection through Wi-Fi
     * @type {string}
     * @memberof EquipmentType
     */
    id: string;
    /**
     * Name of the equipment type, translated.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof EquipmentType
     */
    name: string;
    /**
     * Icon-identifier to represent the equipment. See [SBB pictograms](https://digital.sbb.ch/de/brand_elemente/piktogramme)
     * @type {string}
     * @memberof EquipmentType
     */
    corporateIdentityIcon?: string;
}

/**
 * Check if a given object implements the EquipmentType interface.
 */
export function instanceOfEquipmentType(value: object): value is EquipmentType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function EquipmentTypeFromJSON(json: any): EquipmentType {
    return EquipmentTypeFromJSONTyped(json, false);
}

export function EquipmentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'corporateIdentityIcon': json['corporateIdentityIcon'] == null ? undefined : json['corporateIdentityIcon'],
    };
}

  export function EquipmentTypeToJSON(json: any): EquipmentType {
      return EquipmentTypeToJSONTyped(json, false);
  }

  export function EquipmentTypeToJSONTyped(value?: EquipmentType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'corporateIdentityIcon': value['corporateIdentityIcon'],
    };
}

